import React from 'react'
import PropTypes from 'prop-types'
import { Collapse, Panel } from '../collapse'
import { Box } from '../../atoms/box'
import { Flex } from '../../atoms/flex'
import { Title } from '../../atoms/text'
import { Steps } from '../steps'
import useDeviceDetect from '../../../hooks/useDeviceDetect'

export const ReferAFriendAccountFAQTab = ({ content, faqContent }) => {
  const { isMobile } = useDeviceDetect()
  const steps = content?.steps?.map((item) => item?.content)

  return (
    <Box padding={isMobile ? '0.5em 0 2em 0' : '2em 0'}>
      <Flex direction="column" gap="1.5em">
        <Box>
          <Title level={2}>{content?.steps_title}</Title>
          <Steps steps={steps} />
        </Box>
        <Box>
          <Title level={2}>{faqContent?.faq_title}</Title>
          <Box padding="1em 0">
            <Collapse>
              {faqContent?.faq_rows?.map(({ question, answer }, index) => (
                <Panel header={question} key={index}>
                  {answer}
                </Panel>
              ))}
            </Collapse>
          </Box>
        </Box>
        <Box>
          <Title level={2}>{faqContent?.tc_title}</Title>
          <Box padding="1em 0">
            <Collapse>
              {faqContent?.tc_rows?.map(({ title, description }, index) => (
                <Panel header={title} key={index}>
                  {description}
                </Panel>
              ))}
            </Collapse>
          </Box>
        </Box>
      </Flex>
    </Box>
  )
}

ReferAFriendAccountFAQTab.defaultProps = {
  content: {},
  faqContent: {},
}

ReferAFriendAccountFAQTab.propTypes = {
  content: PropTypes.any,
  faqContent: PropTypes.any,
}
